import { VehicletypeEnum } from "@project-management-system/shared-models";
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('vendor')

export class VendorEntity {
    @PrimaryGeneratedColumn('increment', {
        name: "id"
    })
    id: number

    @Column('varchar', {
        name: 'vendor_name',
        nullable: true
    })
    vendorName: string;

    @Column('varchar', {
        name: 'vendor_code',
        nullable: true
    })
    vendorCode: string;

    @Column('varchar', {
        name: 'gst_number',
        nullable: true
    })
    gstNumber: string;

    @Column('varchar', {
        name: 'vendor_type',
        nullable: false
    })
    vendorType: string;

    @Column('varchar', {
        name: 'contact_person',
        nullable: true
    })
    contactPerson: string;

    @Column('varchar', {
        name: 'phone_number',
        nullable: true
    })
    phoneNumber: string;

    @Column('varchar', {
        name: 'address',
        nullable: true
    })
    address: string;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: 'created_user'
    })
    createdUser: string | null;

    @CreateDateColumn({
        name: "created_at"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @UpdateDateColumn({
        name: "updated_at"
    })
    updatedAt: Date;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;

    @Column('enum', {
        name: 'vehicle_type',
        nullable: true,
        enum:VehicletypeEnum
    })
    vehicleType: VehicletypeEnum;


}